import { render, staticRenderFns } from "./DemographicProfile.vue?vue&type=template&id=a1cb9a8a&scoped=true"
import script from "./DemographicProfile.vue?vue&type=script&lang=js"
export * from "./DemographicProfile.vue?vue&type=script&lang=js"
import style0 from "./DemographicProfile.vue?vue&type=style&index=0&id=a1cb9a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb9a8a",
  null
  
)

export default component.exports